import Immutable from 'seamless-immutable';
import {
  TASK_STARTED,
  TASK_DONE,
  RESET
} from '../actions/general.actions';

const INITIAL_STATE = Immutable({
  working: false,
  runningTask: 0
});

/*
 * Désactivation de la vérification de l'ordre des paramètres par défaut.
 * Redux impose le premier paramètre (l'état) d'un reducer avec une valeur par défaut, or les paramètres par défaut
 * devraient être positionnés en dernier et non en premier.
 */
/* jshint -W138 */
export default function reduce(state = INITIAL_STATE, action) {
  switch (action.type) {
    case TASK_STARTED:
      return state.merge({
        working: true,
        runningTask: state.runningTask + 1
      });
    case TASK_DONE:
      return state.merge({
        working: state.runningTask > 1,
        runningTask: state.runningTask - 1
      });
    case RESET:
      return INITIAL_STATE;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/general.reducer.js